let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fcIvx")).then(() => parcelRequire('3HOfK'));